import { Button } from "@/components/ui/button";
import Landing from "@/layouts/landing";
import FlowSteps from "./FlowSteps";
import { Head } from "@inertiajs/react";

const index = () => {
	return (
		<Landing>
			<main className="flex px-6 bg-white mx-5 rounded-2xl border-2 shadow dark:bg-black">
				<Head title="Home" />
				<section className="grid grid-cols-1 xl:grid-cols-2 gap-12 items-center w-full py-10 xl:py-48">
					<div className="space-y-8 md:px-8 lg:pl-40 xl:pl-6  relative z-10 order-2 xl:order-1">
						<div className="relative mb-3 ">
							<div className="flex items-center gap-2 relative z-10">
								{/* <span className="text-2xl text-black font-semibold">WeAre</span>
								<span className="text-6xl text-black font-[900]">Large</span>
								<span className="text-3xl text-black font-semibold">scale</span> */}
								<span className="text-sm sm:text-lg md:text-xl lg:text-2xl text-black dark:text-white font-semibold">WeAre</span>
								<span className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-black dark:text-white font-[900]">Large</span>
								<span className="text-md sm:text-xl md:text-2xl lg:text-3xl text-black dark:text-white font-semibold">scale</span>
							</div>

							<img
								src="/assets/plane.png"
								alt="plane"
								className="w-25 h-25 sm:w-42 sm:h-42 md:w-48 md:h-48 lg:w-56 lg:h-56 xl:w-64 xl:h-64 object-contain absolute left-[160px] top-[-50px] sm:left-[210px] sm:top-[-90px] md:left-[255px] md:top-[-105px] lg:left-[310px] lg:top-[-120px] xl:left-[315px] xl:top-[-135px] z-0 pointer-events-none"
								style={{
									aspectRatio: '1 / 1',
									objectFit: 'contain',
									marginLeft: '35px',
									paddingBottom: '20px',
									rotate: "21deg"
								}}
							/>
						</div>

						{/* <div className="text-3xl text-black tracking-widest font-medium">
							mail sending company
						</div> */}
						<div className="text-lg sm:text-2xl lg:text-3xl text-black dark:text-white tracking-widest font-medium">
							mail sending company
						</div>

						<p className="text-gray-500 max-w-xl text-sm sm:text-md lg:text-lg leading-relaxed text-justify">
							High-performance email infrastructure provider specializing in delivering
							millions of transactional and SG, MG and PMs every day. We empower startups,
							enterprises, and SaaS platforms to scale their email communications globally
							with speed, reliability, and deliverability.
						</p>

						<Button className="px-6 py-2 text-sm text-white bg-black dark:bg-white dark:text-black dark:hover:bg-slate-200 font-bold">Get Started</Button>
					</div>
					<section className="w-full order-1 xl:order-2">
						<FlowSteps />
					</section>
				</section>
			</main>
		</Landing>
	);
};

export default index;
